export default __webpack_public_path__ + "images/assets/49765c3349ab2c0130e07820918bb681.svg";